var _div, _div2;
import React from 'react';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
function FilterPlaceholder() {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      "data-cmp": "filterPlaceholder",
      children: /*#__PURE__*/_jsx("div", {
        className: "container-fluid padding-4",
        children: /*#__PURE__*/_jsxs("div", {
          className: "row skeleton__loading",
          children: [_div || (_div = /*#__PURE__*/_jsx("div", {
            className: "col-xs-12 margin-bottom-6",
            children: /*#__PURE__*/_jsx("div", {
              className: "skeleton__headline skeleton__placeholder"
            })
          })), /*#__PURE__*/_jsx("div", {
            className: "col-xs-12",
            children: Array(3).fill(_div2 || (_div2 = /*#__PURE__*/_jsxs("div", {
              className: "row",
              children: [/*#__PURE__*/_jsx("div", {
                className: "col-xs-2",
                children: /*#__PURE__*/_jsx("div", {
                  className: "skeleton__text skeleton__placeholder"
                })
              }), /*#__PURE__*/_jsx("div", {
                className: "col-xs-10",
                children: /*#__PURE__*/_jsx("div", {
                  className: "skeleton__text skeleton__placeholder"
                })
              })]
            })))
          })]
        })
      })
    }), /*#__PURE__*/_jsx("hr", {
      className: "margin-0",
      style: {
        borderTop: '1px solid #e1e4e8'
      }
    })]
  });
}
export default FilterPlaceholder;